<template>
  <div>
    <v-card class="py-3 pl-2 headline" elevation="0">
      REPORTES
    </v-card>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="8"
          xl="8"
          class="pt-0 pb-0"
          :class="{ 'pr-0': !$vuetify.breakpoint.smAndDown }"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="6"
              xl="4"
              class="pt-0 pb-0"
              :class="{ 'pr-0': !$vuetify.breakpoint.smAndDown }"
            >
              <v-row>
                <v-col cols="12">
                  <ProsicCompletedChecklist
                    v-if="userAccess['reports-checklist-make']"
                  />
                  <v-card class="pa-3 text-center" v-else>
                    <v-icon>block</v-icon>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <ProsicIncidenceChecklist
                    v-if="userAccess['reports-incidence-reported']"
                  />
                  <v-card class="pa-3 text-center" v-else>
                    <v-icon>block</v-icon>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <ProsicAverageDamageByUser
                    v-if="userAccess['reports-checklist-reported-by-user']"
                  />
                  <v-card class="pa-3 text-center" v-else>
                    <v-icon>block</v-icon>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <ProsicReportByComponent
                    v-if="userAccess['reports-top-incidence']"
                  />
                  <v-card class="pa-3 text-center" v-else>
                    <v-icon>block</v-icon>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <template
              v-if="$vuetify.breakpoint.lgOnly || $vuetify.breakpoint.mdOnly"
            >
              <v-col cols="12" sm="12" md="6" lg="6" xl="4">
                <ProsicUsageReport v-if="userAccess['reports-use-by-user']" />
                <v-card class="pa-3 text-center" v-else>
                  <v-icon>block</v-icon>
                </v-card>
                <ProsicAverageCompletedChecklist
                  class="mt-3"
                  v-if="userAccess['reports-average-completed-checklist']"
                />
                <v-card class="pa-3 mt-3 text-center" v-else>
                  <v-icon>block</v-icon>
                </v-card>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12" sm="12" md="6" lg="6" xl="4">
                <ProsicUsageReport v-if="userAccess['reports-use-by-user']" />
                <v-card class="pa-3 text-center" v-else>
                  <v-icon>block</v-icon>
                </v-card>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" xl="4">
                <ProsicAverageCompletedChecklist
                  v-if="userAccess['reports-average-completed-checklist']"
                />
                <v-card class="pa-3 text-center" v-else>
                  <v-icon>block</v-icon>
                </v-card>
              </v-col>
            </template>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4" xl="4">
          <ProsicGeneralUserReport
            v-if="userAccess['reports-actions-by-user']"
          />
          <v-card class="pa-6 text-center" v-else>
            <v-icon>block</v-icon>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          class="text-center"
          v-if="
            !userAccess['reports-checklist-make'] &&
              !userAccess['reports-incidence-reported'] &&
              !userAccess['reports-average-completed-checklist'] &&
              !userAccess['reports-checklist-reported-by-user'] &&
              !userAccess['reports-top-incidence'] &&
              !userAccess['reports-use-by-user']
          "
        >
          No hay secciones por mostrar para tí, pide a un administrados que te
          otorge los permisos para visualizar
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import IncidenceChecklist from "@/components/analytics/IncidenceChecklist";
import CompletedChecklist from "@/components/analytics/CompletedChecklist";
import AverageCompletedChecklist from "@/components/analytics/AverageCompletedChecklist";
import AverageDamageByUser from "@/components/analytics/AverageDamageByUser";
import ReportByComponent from "../../components/analytics/ReportByComponent";
import UsageReport from "../../components/analytics/UsageReport";
import GeneralUserReport from "../../components/analytics/GeneralUserReport";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("user", ["userAccess"])
  },
  components: {
    ProsicIncidenceChecklist: IncidenceChecklist,
    ProsicCompletedChecklist: CompletedChecklist,
    ProsicAverageCompletedChecklist: AverageCompletedChecklist,
    ProsicAverageDamageByUser: AverageDamageByUser,
    ProsicReportByComponent: ReportByComponent,
    ProsicGeneralUserReport: GeneralUserReport,
    ProsicUsageReport: UsageReport
  }
};
</script>
